import {
  ColDef
} from '@ag-grid-enterprise/all-modules';
import { DateRange } from '@blueprintjs/datetime';

export const logsColumnDefs: ColDef[] = [
  {
    field: 'timestamp',
    resizable: true,
    width: 150
  },
  {
    field: 'severity',
    resizable: true,
    width: 100
  },
  {
    field: 'message',
    resizable: true,
    minWidth: 250,
    flex: 1
  },
  {
    field: 'processName',
    resizable: true,
    width: 150
  },
  {
    field: 'sourceFileName',
    resizable: true,
    width: 150
  },
  {
    field: 'sourceLineNum',
    resizable: true,
    width: 115
  },
  {
    field: 'hostname',
    resizable: true,
    width: 198
  },
  {
    field: 'clustername',
    resizable: true,
    width: 150
  },
  {
    field: 'index',
    resizable: true,
    minWidth: 180,
    hide: true
  },
];

export interface LogFilterCriteria {
  dateRange: DateRange;
}
